import { createContext, type ReactNode, useContext, useMemo } from 'react';
import type { ClockType } from '@/models/common/clock.ts';

export type NowContextType = {
  clock: ClockType;
};

const ClockContext = createContext<NowContextType | undefined>(undefined);

export const ClockProvider = ({
  children,
  clock,
}: {
  children: ReactNode;
  clock: ClockType;
}) => {
  const value = useMemo(() => ({ clock }), [clock]);

  return <ClockContext value={value}>{children}</ClockContext>;
};

export const useClock = () => {
  const context = useContext(ClockContext);
  if (!context) throw new Error('useClock must be used within a ClockContext');
  return context;
};
